import { declareString } from "@1js/localization";

export const MakeItYourOwnLabel = declareString(
  "promptLibrary.makeItYourOwnLabel",
  {
    text: "Make it your own",
    comment:
      "Heading that appears above make it your own section. When a user clicks on a prompt card, a dialog opens up. Make it your own is the title of a section that contains information on how to modify or use the prompt.",
  }
);
